export const customersAlertId = 'customersAlert';
export const customersFormModalId = 'customersFormModalId';
export const customerFormSendDocumentModalId = 'customerFormSendDocumentModalId';
export const customerSendFileModalId = 'customerSendFileModal';
export const customerFormDeleteModalId = 'customerFormDeleteModal';
export const customerFilterFormId = 'customerFilterForm';
